import {SiteType} from '@wp-content-publisher/typings-lib/dist/src/server/types/site.ts';
import {apiRequest} from '../../../shared/utils/api-request.helper.ts';


export const getSiteList = async (): Promise<SiteType[]> =>
    await apiRequest({
        url: `/sites`
    });